import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

import {useClassNames} from "../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from "../../Common/StreamBankPageHeader";
import {ForgotPasswordComponent} from "./ForgotPasswordComponent";
import {useSelector} from "react-redux";

export const ForgotPasswordPage = props => {
    const classNames = useClassNames('sb-forgot-password-page');
    const {errors} = useSelector(state => state.loginState);

    return <Container className={classNames}>
        <div className="login-page">
            <StreamBankPageHeader
                Title={"Forgot Password"}
            />
            <Row key={1}>
                <Col xs={12} md={12}>
                    <h2>Forgot Password</h2>
                    <hr />
                </Col>
            </Row>
            {
                (errors.reset) &&
                <Row key={3}>
                    <Col xs={12}>
                        <p className="sb-login-popup-container-error-message">{errors.reset}</p>
                    </Col>
                </Row>
            }
            <Row key={2}>
                <ForgotPasswordComponent />
            </Row>
        </div>
    </Container>;
}


